import { bl_alg_cc_mst_grp_skill_link_RowClass } from "../../../dbschema/bl_alg_cc_mst_group_skill_link.model";
import { BaseContainerModel } from "../../base-container.model";

export class MstGroupSkillLinkContainerModel extends BaseContainerModel{
  bl_alg_cc_mst_grp_skill_link: bl_alg_cc_mst_grp_skill_link_RowClass = new bl_alg_cc_mst_grp_skill_link_RowClass();
}